import * as React from 'react';
import PropTypes from 'prop-types';

import ClassroomActiveCardCommon from '../../../cross-platform/home/ClassroomActive.card.common';
import ClassroomActiveCardElectron from '../../../cross-platform/home/ClassroomActive.card.electron';

const propTypes = {
  id: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  studentsCount: PropTypes.number.isRequired,
  isDragging: PropTypes.bool,
  extraMenuOptions: PropTypes.any,
  classCode: PropTypes.string
};

const electronVersion = props => <ClassroomActiveCardElectron {...props} />;
electronVersion.propTypes = propTypes;

const webVersion = props => <ClassroomActiveCardCommon {...props} />;
webVersion.propTypes = propTypes;

const versions = {
  electron: electronVersion,
  web: webVersion
};

export let ClassroomActiveCard;
export let configure = mode => {
  ClassroomActiveCard = versions[mode];
};
